import { render } from "./RegisterOutstandingOrder.vue?vue&type=template&id=5c5174c7"
import script from "./RegisterOutstandingOrder.vue?vue&type=script&lang=js"
export * from "./RegisterOutstandingOrder.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__